import '../../styles/sections/section-tax-disclaimer.scss'

import { register } from '@shopify/theme-sections'

export default register(`section-tax-disclaimer`, {

    onLoad() {
    },

    onUnload() {
    },
})
